
export const BACKEND_URL = "https://stagapi.gofirefly.io/api";
export const K8S_API = "https://k8s-api.stag.external.api.infralight.cloud"
export const AUTH0_NS = "https://infralight.co"
export const AUTH0_DOMAIN = "stagauth.gofirefly.io"
export const AUTH0_CLIENT_ID = "5z14RCSzMxyEuX2vwlenLjWXTZKhl3Wq"
export const AUTH0_AUDIENCE = "infralight-api"
export const CLI_LINK_PREFIX = "app"
export const INTERCOM_ID = "s74z1ux7"
export const S3_ASSETS = "https://firefly-app-assets.s3.amazonaws.com"
export const AMPLITUDE_API_KEY = "c6b8b4a0eb84688638fc6c1bdf8c8d0f"
export const AMPLITUDE_API_KEY_STAG = "f8358e6538bbbdce2250a0d4fb49b9e2"
export const GOOGLE_TAG_ID = "GTM-KLW952G"
export const CODE_COMMIT_TEMPLATE = "https://infralight-templates-public.s3.amazonaws.com/codecommit/template.yml"
export const MUI_X_LICENSE_KEY = "145b827932f3f4afe1b03ff34e9ff64bTz03ODg1MSxFPTE3MzE3NTE5NzgwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI="

